module.exports = __webpack_public_path__ + "dash_20_app_assets/img/gp.76ed6f2f.png";